<template lang="pug">
  component.pdp-swatch-button.btn-reset.xs-f-small.max-at-tweak(:is="url ? 'router-link' : 'button'" :to="url ? url : undefined" @click="click" @keyup.enter="click" :class="swatchClasses")
    .swatch
      .swatch-inner
        img.full-width(:src="imgUrl" :alt="imgAltText" loading="lazy")
      span(v-if="innerText").inner-text.xs-f-xxsmall.max-at-tweak.upper {{ innerText }}

    span.swatch-text.text-color-2.max-at-tweak.xs-12(v-html="label" :class="labelClasses")
    span.ada-tooltip(v-if="selected") selected
</template>

<script>
  export default {
    name: "PdpSwatchButton",

    props: {
      selected: {
        type: Boolean,
        required: true,
      },
      imgUrl: {
        type: String,
        required: false,
        default: '',
      },
      imgAltText: {
        type: String,
        required: false,
        default: '',
      },
      label: {
        type: String,
        required: true
      },
      labelExtraClasses: {
        type: Array,
        required: false,
        default: () => []
      },
      innerText: {
        type: String,
        required: false,
        default: null
      },
      hideLabel: {
        type: Boolean,
        default: false
      },
      url: {
        type: String,
        required: false,
        default: ''
      }
    },

    computed: {
      swatchClasses() {
        let classes = [];

        if (this.selected) {
          classes.push('selected');
        } else {
          if (this.innerText == 'original') {
            classes.push('original-swatch');
          }
        }


        return classes;
      },

      labelClasses() {
        let classes = [];

        if (this.hideLabel) {
          classes.push('ada-tooltip');
        }

        if (this.selected) {
          classes.push('bold');
        }

        if (this.labelExtraClasses.length) {
          classes = classes.concat(this.labelExtraClasses);
        } else {
          classes.push('xs-f-xsmall');
        }

        return classes;
      }
    },

    methods: {
      click(e) {
        /* suppress any consecutive clicks, i.e. a dblclick is treated as a single click */
        if (e.detail === 1 || e.key === 'Enter') {
          this.$emit('click');
        }
      }
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-swatch-button
    display inline-block
    vertical-align top
    padding-right 0.25em
    text-align center
    white-space normal

    .swatch
      position relative
      display inline-block
      width 4.5em
      height 4.5em
      border-radius 50%
      padding 0px
      border 4px solid transparent

      .swatch-inner
        position relative
        width 100%
        height 100%
        border-radius 50%
        overflow hidden

        img
          pointer-events none

      .inner-text
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        color white

    &.selected
      .swatch
        border-color brand-color-2
        padding 4px

    &.original-swatch
      .swatch
        border-color ui-color-5

    .swatch-text
      display inline-block
      margin-top 0.25em

    &:disabled
      opacity 0.5

    @media mq-mobile
      .swatch
        width 4.5em
        height 4.5em

</style>
